import { tw } from '@/utils/tw';
import InputCaptionTheme from 'base/components/InputCaption/theme';

const Caption = tw.theme({
  extend: InputCaptionTheme,
  base: 'text-input-sm group-data-[status=error]:text-primary-800',
});

export default Caption;
